module.exports = __webpack_public_path__ + "img/404-not-found.cb3b50f0.svg";